var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagKosovo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02806 10.0098L7.37344 11.0728H8.49094L7.58687 11.7296L7.93219 12.7924L7.02806 12.1356L6.12387 12.7924L6.46931 11.7296L5.56519 11.0728H6.68262L7.02806 10.0098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5063 8.96631L10.8517 10.0292H11.9692L11.0651 10.6861L11.4104 11.7489L10.5063 11.0921L9.60219 11.7489L9.94757 10.6861L9.0435 10.0292H10.161L10.5063 8.96631Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.985 7.92285L14.3304 8.98579H15.4479L14.5438 9.64266L14.8892 10.7055L13.985 10.0486L13.0809 10.7055L13.4263 9.64266L12.5222 8.98579H13.6397L13.985 7.92285Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9724 10.0098L24.627 11.0728H23.5095L24.4136 11.7296L24.0683 12.7924L24.9724 12.1356L25.8766 12.7924L25.5311 11.7296L26.4353 11.0728H25.3178L24.9724 10.0098Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4937 8.96631L21.1483 10.0292H20.0308L20.9349 10.6861L20.5896 11.7489L21.4937 11.0921L22.3978 11.7489L22.0524 10.6861L22.9565 10.0292H21.839L21.4937 8.96631Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0154 7.92285L17.6701 8.98579H16.5526L17.4566 9.64266L17.1113 10.7055L18.0154 10.0486L18.9196 10.7055L18.5742 9.64266L19.4783 8.98579H18.3608L18.0154 7.92285Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.783 16.966L16.0004 13.4878L14.6091 14.1834V15.5747L12.5222 16.966H11.1309V18.7635C13.1701 19.5892 14.6091 21.5873 14.6091 23.9226H16.0004V22.5313L17.3917 21.14L18.783 22.5313L20.1744 21.14V19.7487L21.5657 17.6617L18.783 16.966Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagKosovo);
export default __webpack_public_path__ + "static/media/flag_kosovo.75109817e479ce0cda150ee9fd8323cb.svg";
export { ForwardRef as ReactComponent };